import * as React from 'react';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export interface IColumnData {
  id: string;
  label: string;
  sortable?: boolean;
}

interface IProps {
  order: 'asc' | 'desc';
  orderBy: string;
  columnData: IColumnData[];
  onRequestSort(property: string): void;
}

export class ResponsiveTableHead extends React.Component<IProps> {
  /**
   * event handlers pass the event as the first parameter
   * wrap handler in an additional function to preserve the
   * property parameter for use in sorting
   */
  createSortHandler = (property: string) => (event: React.MouseEvent) => {
    this.props.onRequestSort(property);
  };

  render(): JSX.Element {
    const { order, orderBy, columnData } = this.props; // TODO figure out about column width

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                sortDirection={orderBy === column.id ? order : false}
              >
                {column.sortable || column.sortable === undefined ? (
                  <Tooltip // treat undefined as true to avoid specifying EVERYTHING
                    title="Sort"
                    placement={'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={this.createSortHandler(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </Tooltip>
                ) : (
                  column.label
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

export default ResponsiveTableHead;



// WEBPACK FOOTER //
// ./src/common/responsive-table/responsive-table-head.tsx